// extracted by mini-css-extract-plugin
export var container = "Privacy-module--container--SJUy-";
export var po = "Privacy-module--po--XvVlC";
export var po_pic_cont = "Privacy-module--po_pic_cont--XklOC";
export var po_pic = "Privacy-module--po_pic--FVDVi";
export var po_text_area = "Privacy-module--po_text_area--L5mmb";